export const MARKDOWN_COPY_BUTTON_ID = 'data-copy-for';
export const MARKDOWN_EXECUTE_BUTTON_ID = 'data-execute-for';
export const MARKDOWN_SNIPPET_ID = 'data-snippet-id';
